import { normalize } from 'normalizr';
import { hasMore, isMicrosResponse } from './middleware-helpers';
import { ACTION_SUCCESS, ACTION_FETCHING, ACTION_ERROR } from '../constants/action-status';
import { errorActionCreator } from '../actions/index';
import { createErrorByStatusCode } from './rest-error-handler';

/*eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */

export const promiseMiddleware =
	() =>
	({ dispatch }) =>
	(next) =>
	(action) => {
		const { promise, transformer, type, meta, params } = action;

		//  If we haven't received a promise, we treat this as a normal action.
		if (!promise) {
			return next(action);
		} else {
			console.log(`Promise middleware invoked for ... ${type}`);
		}

		//  Dispatch an action which tells our application that the data for
		//  this action is currently being fetched.
		dispatch({
			type: `${type}_${ACTION_FETCHING}`,
			params,
			payload: {},
		});

		//  Invoke the passed promise, and the correct action as per the response
		//  result/code.
		return promise()
			.then((result = {}) => {
				console.log(`Dispatching ... ${type}_${ACTION_SUCCESS}`);

				const transformedResult = transformer ? transformer(result) : result;
				const results = meta.schema ? normalize(transformedResult, meta.schema) : transformedResult;
				const payload = {
					results,
					_links: result._links || {},
					hasMore: hasMore(result),
					next: isMicrosResponse(result) ? result.next || null : null,
				};

				return dispatch({
					type: `${type}_${ACTION_SUCCESS}`,
					params,
					payload,
				});
			})
			.catch((error) => {
				console.log(`Dispatching ... ${type}_${ACTION_ERROR}, status code: ${error.status}`);
				console.error('Error: ', error);

				const errorData = createErrorByStatusCode(error);
				return dispatch(errorActionCreator(type, [errorData], params));
			});
	};

export default promiseMiddleware;
